import HeaderUserControls from  "../modules/header-user-controls";
import HeaderTags from  "../modules/header-tags";
import $ from "jquery";

class Header {
    constructor() {
        $('[data-id="mainheader__container"]').each(function () {
            new HeaderUserControls(this)
        });
        $('[data-id="header_tags"]').each(function () {
            new HeaderTags(this)
        });
    }
}

export default Header;